<template>
    <div class="footer-content">
        <div class="logo">
            <img src="../assets/logo-footer.webp" alt="logo" />
            SWIFTBIT COMPANY LIMITED
        </div>
        <div class="text">
            MoneyElephant ดำเนินการพัฒนาเทคโนโลยีและบริการลูกค้าโดย SWIFTBIT COMPANY LIMITED
            บริการสินเชื่อทั้งหมดให้บริการโดย MONEYBAY COMPANY LIMITED
            ซึ่งได้รับใบอนุญาตพิโกไฟแนนซ์จากกระทรวงการคลังแห่งประเทศไทย และอยู่ภายใต้การกำกับดูแลอย่างเป็นทางการ
            เรามุ่งมั่นในการให้บริการที่ปลอดภัย โปร่งใส และเป็นไปตามกฎหมาย
            เพื่อมอบประสบการณ์สินเชื่อส่วนบุคคลที่เชื่อถือได้แก่ผู้ใช้ทุกคน
        </div>
        <div class="content">
            <div class="page">หน้า</div>
            <div class="page" @click="handleClick('/')">
                หน้าแรก
            </div>
            <div class="page" @click="handleClick('/service')">
                บริการ
            </div>
            <div class="page" @click="handleClick('/about')">
                เกี่ยวกับเรา
            </div>
            <div class="page" @click="handleClick('/contact')">
                ติดต่อเรา
            </div>
        </div>
        <div class="contact">
            <div class="item" v-for="item in list" :key="item.index">
                <img :src="require('@/assets/footer-icon' + item.index + '.webp')" alt="">
                {{ item.content }}
            </div>
        </div>
        <div class="bottom">
            © 2025 Copyright belongs to SWIFTBIT COMPANY LIMITED
        </div>
    </div>
</template>
<script setup>
import { useRouter } from "vue-router";
const router = useRouter();
const handleClick = (path) => {
    router.push(path);
    window.scrollTo(0, 0);
};
const list = [
    {
        content: "เลขที่ 269 หมู่ที่ 2 ตำบลหนองดินแดง อำเภอเมืองนครปฐม จังหวัดนครปฐม",
        index: 1,
    },
    {
        content: "0614531326",
        index: 2,
    },
    {
        content: "service@swiftbit-limit.com",
        index: 3,
    },
];
</script>
<style lang="less" scoped>
.footer-content {
    width: 100%;
    height: 301px;
    box-sizing: border-box;
    background-color: #303030;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 25px;
    color: #D3D3D3;

    .logo {
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 15px;
        line-height: 15px;

        img {
            width: 43px;
            height: 43px;
            object-fit: contain;
            margin-right: 12px;
        }
    }

    .text {
        max-width: 707px;
        font-weight: 500;
        font-size: 12px;
        color: #D3D3D3;
        line-height: 16px;
        margin-top: 14px;
    }

    .content {
        width: 50%;
        margin-top: 27px;
        display: flex;
        justify-content: space-between;

        .page {
            font-weight: bold;
            font-size: 14px;
            line-height: 15px;
            cursor: pointer;
        }
    }

    .contact {
        width: 60%;
        margin-top: 38px;
        display: flex;
        justify-content: space-between;

        .item {
            display: flex;
            align-items: center;
            font-weight: 500;
            font-size: 12px;
            line-height: 18px;

            img {
                width: 17px;
                height: 17px;
                object-fit: cover;
                margin-right: 8px;
            }
        }
    }

    .bottom {
        margin-top: 33px;
        font-weight: 500;
        font-size: 11px;
        color: #EAEAEA;
        line-height: 24px;
    }
}
</style>